<template>
  <a class="block p-2 border-b hover:bg-main hover:text-white cursor-pointer st-all" v-if="category.descendants.length == 0" :href="`/categorias/${category.slug}`">{{ category.name }}</a>
  <div v-else>
    <div class="flex flex-row items-center border-b cursor-pointer">
      <a :href="`/categorias/${category.slug}`" class="flex-1 p-2 block hover:text-white hover:bg-main st-all">{{ category.name }}</a>
      <div class="p-2 flex-none border-l hover:bg-main hover:text-white st-all" @click="isCatOpen = !isCatOpen"><action-icons :icon="isCatOpen ? 'caret-up' : 'caret-down'" /></div>
    </div>
    <div class="relative overflow-hidden bg-gray-200">
      <div class="ml-4 bg-white" ref="childrenHolder" style="transition: margin-top 0.35s;" :style="{ marginTop: isCatOpen ? '0' : `-${childrenHeight}px` }">
        <main-nav-item :category="child" :key="`cat-${child.slug}`" v-for="child in category.descendants" />
        <a class="block p-2 border-b hover:bg-main hover:text-white cursor-pointer st-all" v-if="category.id == btbMainCategory" href="/b2b/kitchen-solutions">Kitchen Solutions</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'main-nav-item',
  props: {
    category: {
      type: Object,
      default() {
        return {};
      }
    },
    btbMainCategory: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      isCatOpen: false,
      childrenHeight: 0,
    }
  },
  mounted() {
    if (this.category.descendants.length > 0) {
      this.childrenHeight = this.$refs.childrenHolder.offsetHeight;
    }
  }
}
</script>